import { render, staticRenderFns } from "./BrandingStyle.vue?vue&type=template&id=14fc7200&"
import script from "./BrandingStyle.vue?vue&type=script&lang=js&"
export * from "./BrandingStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports